import React, { Component } from "react";
import axios from "axios";
import { connect } from "react-redux";
import Icon from "./Icons";

import { fetchAppearanceSettings, l } from "../functions";

import GKEvent from "../events";
import { Select, TextField } from "./FormElements";
import { ajaxUri } from "../consts/index";
import ColorSetter from "./NewColorPicker";
import SliderRange from "./SliderRange";
import HeaderSetting from "./HeaderSetting";
import { fontList as globalFontList } from "../consts/fonts";
import SizeSetter from "./SizeSetter";
import { HighlightSharp } from "@material-ui/icons";

const mapStateToProps = (state) => {
  return {
    fetchedThemes: state.rootReducer.fetchedThemes || {},
    settings: state.rootReducer.appearanceSettings || {},
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    dispatchSetting: (setting) => {
      return dispatch({ type: "SET_APPEARANCE", settings: setting });
    },
  };
};
class ThemeAppearance extends Component {
  constructor(props) {
    super(props);

    this.defaultSettings = {
      fontFamily: null,
      settings: {},
      currentDropDown: null,
    };

    this.defaultState = {
      fontFamily: null,
      settings: this.props.settings,
      currentDropDown: null,
      currentTab: this.props.currentTab || 1,
    };

    this.state = {
      ...this.defaultState,
    };
    this.weightLabel = {
      200: "Extra light",
      300: "Light",
      400: "Regular",
      500: "Medium",
      600: "Semi bold",
      700: "Bold",
      800: "Extra bold",
      900: "Black",
    };
  }

  resetToDefaultSettings() {
    this.setState(...this.defaultSettings);
  }

  componentDidMount() {
    this.setState({
      settings: {
        ...this.props.settings,
        active_button_color: {
          bgColor:
            this.props.settings.active_button_color?.bgColor || "#2f862d",
        },
        active_button_text_color: {
          color: this.props.settings.active_button_text_color?.color || "#fff",
        },
      },
    });

    // fetchAppearanceSettings();
  }

  fontList = globalFontList;

  _fontsFamilyOptions = () => {
    let object = [];

    this.fontList.forEach((font, index) => {
      object.push({
        label: font.name.split("+").join(" "),
        value: index.toString(),
        props: {
          style: { fontFamily: font.cssName },
        },
      });
    });

    return object;
  };

  _changeFontFamily = (id, value) => {
    const fontFamilySetting = {
      fontFamilyId: value,
      fontFamily: this.fontList[value].cssName,
    };
    if (id === "FONT_FAMILY") {
      this.setState(
        {
          settings: { ...this.state.settings, [id]: fontFamilySetting },
        },
        () => {
          this.props.dispatchSetting(this.props.settings);
        }
      );
    } else {
      return fontFamilySetting;
    }
  };
  _changeSetting = (key, val, group) => {
    let setting = this.state.settings[group];
    let settings = this.state.settings;
    if (key === "font") {
      const fonts = this._changeFontFamily(group, val);
      this.setState({ settings: { ...settings, [group]: fonts } }, () => {
        this.props.dispatchSetting(this.state.settings);
      });
      return;
    }
    if (key === "fontFamily") {
      setting = {
        ...setting,
        [key]: this._changeFontFamily(group, val),
      };
    } else {
      setting = {
        ...setting,
        [key]: val,
      };
    }

    this.setState(
      { settings: { ...this.state.settings, [group]: setting } },
      () => {
        this.props.dispatchSetting(this.state.settings);
      }
    );
  };

  _saveSettings = () => {
    const settings = this.state.settings;

    axios
      .post(ajaxUri, {
        request: "setAppearanceSetting",
        settings: JSON.stringify(settings),
      })
      .then((response) => {
        GKEvent.notification("success", "Appearance Settings updated");
        this.props.dispatchSetting(settings);
      })
      .catch((err) => {
        console.log(err);
        GKEvent.notification("error", "Something is wrong");
      });
  };

  _setCurrentDropDown = (current) => {
    if (this.state.currentDropDown === current) {
      this.setState({ currentDropDown: null });
    } else {
      this.setState({ currentDropDown: current });
    }
  };

  _fontsWeightOptions = (fontId, fontFamily) => {
    let object = [];

    if (fontId && fontFamily) {
      this.fontList[fontId].weight.forEach((weight) => {
        object.push({
          label: this.weightLabel[weight],
          value: weight,
          props: {
            style: { fontFamily: fontFamily, fontWeight: weight },
          },
        });
      });
    }

    return object;
  };

  render() {
    return (
      <div className="block-settings">
        <div className="head-wraper">
          {" "}
          <div className="head">
            <Icon
              icon="time"
              onClick={() => {
                this.props.editElement(null);
              }}
            />
            <h3>{l("Customize")}</h3>
          </div>
          <ul className="tab-head">
            <li
              className={this.state.currentTab == 1 ? "active" : ""}
              onClick={() => this.setState({ currentTab: 1 })}
            >
              {" "}
              Appearance
            </li>
            <li
              className={this.state.currentTab == 2 ? "active" : ""}
              onClick={() => this.setState({ currentTab: 2 })}
            >
              Header
            </li>
          </ul>
        </div>

        {this.state.currentTab == 1 && (
          <div>
            <div className="appearance-head">
              <button
                className="new-item"
                onClick={() => {
                  this._saveSettings();
                }}
              >
                <Icon icon="check" />
              </button>
            </div>
            <div className="theme-setting-block">
              <div className="block-section" style={{ paddingTop: 8 }}>
                <h1 className="heading">Typography</h1>
                <div>
                  <div className="selector-flex">
                    <FontSelector
                      onChange={(value) => {
                        this._changeSetting("font", value, "heading_font");
                      }}
                      title={"Heading Font"}
                      value={
                        this.state.settings["heading_font"]?.fontFamilyId || ""
                      }
                      placeholder={l("Font Family")}
                      options={this._fontsFamilyOptions()}
                    />
                    <FontSelector
                      onChange={(value) => {
                        this._changeSetting("font", value, "body_font");
                      }}
                      title={"Body Font"}
                      value={
                        this.state.settings["body_font"]?.fontFamilyId || ""
                      }
                      placeholder={l("Font Family")}
                      options={this._fontsFamilyOptions()}
                    />
                  </div>
                </div>
                <div>
                  <SizeSetter
                    min={2}
                    max={64}
                    value={this.state.settings["H1"]?.size || 16}
                    onChange={(val) => {
                      this._changeSetting("size", val, "H1");
                    }}
                    title="Heading (H1)"
                  />
                  <SizeSetter
                    min={2}
                    max={64}
                    value={this.state.settings["H2"]?.size || 16}
                    onChange={(val) => {
                      this._changeSetting("size", val, "H2");
                    }}
                    title="Sub Heading (H2)"
                  />
                  <SizeSetter
                    min={2}
                    max={64}
                    value={this.state.settings["H3"]?.size || 16}
                    onChange={(val) => {
                      this._changeSetting("size", val, "H3");
                    }}
                    title="Title (H3)"
                  />
                  <SizeSetter
                    min={2}
                    max={64}
                    value={this.state.settings["H4"]?.size || 16}
                    onChange={(val) => {
                      this._changeSetting("size", val, "H4");
                    }}
                    title="Sub Title (H4)"
                  />
                  <SizeSetter
                    min={2}
                    max={64}
                    value={this.state.settings["body"]?.size || 16}
                    onChange={(val) => {
                      this._changeSetting("size", val, "body");
                    }}
                    title="Body Size"
                  />
                  <SizeSetter
                    min={2}
                    max={64}
                    value={this.state.settings["semiBody"]?.size || 16}
                    onChange={(val) => {
                      this._changeSetting("size", val, "semiBody");
                    }}
                    semiBody
                    title="Label Size"
                  />
                </div>
              </div>
            </div>

            <div className="theme-setting-block">
              <div className="block-section" style={{ paddingTop: 8 }}>
                <h1 className="heading">Colors</h1>
                <div>
                  <div className="setting-grp">
                    <p>Heading Font</p>
                    <ColorSetter
                      color={this.state.settings["heading_color"]?.color || ""}
                      onChangeComplete={(val) => {
                        this._changeSetting("color", val, "heading_color");
                      }}
                      right
                    />
                  </div>
                  <div className="setting-grp">
                    <p>Body Font</p>
                    <ColorSetter
                      color={this.state.settings["body_color"]?.color || ""}
                      onChangeComplete={(val) => {
                        this._changeSetting("color", val, "body_color");
                      }}
                      right
                    />
                  </div>
                  <div className="setting-grp">
                    <p>Label</p>
                    <ColorSetter
                      color={
                        this.state.settings["semi_body_color"]?.color || ""
                      }
                      onChangeComplete={(val) => {
                        this._changeSetting("color", val, "semi_body_color");
                      }}
                      right
                    />
                  </div>
                  <div className="setting-grp">
                    <p>Links</p>
                    <ColorSetter
                      color={this.state.settings["links_color"]?.color || ""}
                      onChangeComplete={(val) => {
                        this._changeSetting("color", val, "links_color");
                      }}
                      right
                    />
                  </div>
                  <div className="setting-grp">
                    <p>Button</p>
                    <ColorSetter
                      color={this.state.settings["button_color"]?.bgColor || ""}
                      onChangeComplete={(val) => {
                        this._changeSetting("bgColor", val, "button_color");
                      }}
                      right
                    />
                  </div>

                  <div className="setting-grp">
                    <p>Button Text</p>
                    <ColorSetter
                      color={
                        this.state.settings["button_text_color"]?.color || ""
                      }
                      onChangeComplete={(val) => {
                        this._changeSetting("color", val, "button_text_color");
                      }}
                      right
                    />
                  </div>
                  <div className="setting-grp">
                    <p>Active Button</p>
                    <ColorSetter
                      color={
                        this.state.settings["active_button_color"]?.bgColor ||
                        ""
                      }
                      onChangeComplete={(val) => {
                        this._changeSetting(
                          "bgColor",
                          val,
                          "active_button_color"
                        );
                      }}
                      right
                    />
                  </div>
                  <div className="setting-grp">
                    <p>Active Button Text</p>
                    <ColorSetter
                      color={
                        this.state.settings["active_button_text_color"]
                          ?.color || ""
                      }
                      onChangeComplete={(val) => {
                        this._changeSetting(
                          "color",
                          val,
                          "active_button_text_color"
                        );
                      }}
                      right
                    />
                  </div>
                  <div className="setting-grp">
                    <p>Price</p>
                    <ColorSetter
                      color={this.state.settings["price_color"]?.color || ""}
                      onChangeComplete={(val) => {
                        this._changeSetting("color", val, "price_color");
                      }}
                      up
                      right
                    />
                  </div>
                  <div className="setting-grp">
                    <p>Old Price</p>
                    <ColorSetter
                      color={
                        this.state.settings["old_price_color"]?.color || ""
                      }
                      onChangeComplete={(val) => {
                        this._changeSetting("color", val, "old_price_color");
                      }}
                      up
                      right
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {this.state.currentTab == 2 && <HeaderSetting />}
      </div>
    );
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(ThemeAppearance);

const FontSelector = (props) => {
  return (
    <div className="font-selector">
      <h1 className="font-selector-title">{props.title}</h1>
      <Select
        value={props.value || ""}
        onChange={props.onChange}
        placeholder={props.placeholder}
        options={props?.options}
        dark
      />
    </div>
  );
};
